import { CommonModule } from '@angular/common';
import { Component, Input} from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'so-search-input',
  templateUrl: './so-search-input.component.html',
  styleUrls: ['./so-search-input.component.css'],
  standalone: true,
  imports: [ 
    CommonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,    
    ReactiveFormsModule
  ]
})
export class SoSearchInputComponent {
  @Input() searchCtrl = new FormControl('');
  @Input() placeHolder = "Search";

  onKeydown(e: KeyboardEvent, i: HTMLInputElement) {
    i.onkeydown?.(e);
    e.stopPropagation();
  }
  clearSearch() {
    this.searchCtrl.setValue(""); 
  }
}
